import React from "react";
import "./saldoMoedaChip.css";

const SaldoMoedaChip = ({ saldo }) => {
  return (
    <div
      className="saldo-moeda-chip"
      onClick={() => (window.location.href = "/acesso")}
      role="button"
    >
      <img src="/moeda.png" alt="Moedas" className="saldo-moeda-icone" />
      <span className="saldo-moeda-numero">{saldo ?? 0}</span>
    </div>
  );
};

export default SaldoMoedaChip;